var React = require('react');

class ToggleDebugger extends React.Component {
    constructor(props) {
        super(props);

        this.wrapperStyle = {
            position: 'absolute',
            top: '200px',
            left: '-150px',
            backgroundColor: '#F8DF8D',
            color: 'black',
            zIndex: 999,
            border: '3px solid black',
            borderRadius: '5px',
            margin: '10px',
            padding: '10px'
        }

    }

    render() {
        return <div className={"toggle-debugger-container"} style={this.wrapperStyle}>
            <span>Debug  </span>
            <input type="checkbox" onClick={this.props.toggleDebugger} checked={this.props.debugMode}/>
        </div>;
    }
}

module.exports = ToggleDebugger;